export const config = {
  menuItemHorizontalPadding: 32,
  menuItemMaxWidth: 260,
};
